export const checkIsLiveArticle = clickActionUrl => {
  const result = {
    hashValue: "",
    isLiveArticle: false
  };
  try {
    var _hash$startsWith;
    const {
      hash
    } = new URL(clickActionUrl);
    if (hash !== null && hash !== void 0 && (_hash$startsWith = hash.startsWith) !== null && _hash$startsWith !== void 0 && _hash$startsWith.call(hash, "#live")) {
      result.hashValue = hash;
      result.isLiveArticle = true;
    }
  } catch (error) {
    console.error(new Error("Failed to check live article", {
      cause: error
    }));
  }
  return result;
};